import { createAsyncThunk } from '@reduxjs/toolkit';
import { StoreState } from '../../../store/store.interface';
import { ActionStatus } from '../../../common/constants/action-status';
import { cancelFreeTrialApiCall } from '../apis/free-trial.api';
import { FreeTrialCancelRequest } from '../interfaces/free-trial-cancel.interface';

export const cancelFreeTrial = createAsyncThunk(
  'freeTrial/cancel',
  async (request: FreeTrialCancelRequest, thunkAPI) => {
    try {
      return await cancelFreeTrialApiCall(request)
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    } 
  },
  {
    condition: (_: any, {getState}) => {
      const state = getState() as StoreState;
      return ActionStatus.loading !== state.freeTrialState.freeTrialCancel.status;
    },
  }
);